import React, { useState } from "react";
//import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { FaDirections } from "react-icons/fa";

const cardStyle = {
    position: "absolute",
    top: "10px",
    left: "10px",
    backgroundColor: "white",
    padding: "15px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    zIndex: "10",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "90%",
    maxWidth: "340px",
    flexWrap: "wrap",
};

const addressStyle = {
    marginRight: "10px",
    flex: "1 1 70%",
    wordWrap: "break-word",
};

const addressS = {
    fontWeight: "500",
    fontSize: "14px",
    color: "rgba(0, 0, 0, 0.87)",
    lineHeight: "1.5em",
};

const buttonStyle = {
    backgroundColor: "#4285F4",
    color: "white",
    padding: "8px 12px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    flex: "1 1 25%",
    justifyContent: "center",
};

const containerStyle = {
    width: "100%",
    height: "400px",
    position: "relative",
};

function Map({ googleMapsApiKey, lat, lng, address }) {
    const [isApiLoaded, setIsApiLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);

    const parsedLat = parseFloat(lat);
    const parsedLng = parseFloat(lng);

    const center = {
        lat: parsedLat || 0,
        lng: parsedLng || 0,
    };
    const { isLoaded, loadError } = useJsApiLoader({
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    });

    const getDirectionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${parsedLat},${parsedLng}`;

    if (loadError) return <div>Error loading map</div>;
    if (!isLoaded) return <div>Loading map...</div>;

    return (
        <div style={containerStyle}>
            <div style={containerStyle}>
      {/* Desktop layout */}
      <div className="hidden md:block mb-4">
        <div className="address-card" style={cardStyle}>
          <div style={addressStyle}>
            <p style={addressS}>{address}</p>
          </div>
          <a href={getDirectionsUrl} target="_blank" rel="noopener noreferrer">
            <button style={buttonStyle}>
              <FaDirections style={{ marginRight: "8px" }} />
              Get Directions
            </button>
          </a>
        </div>
        <GoogleMap
          mapContainerStyle={{ width: "100%", height: "400px" }}
          center={center}
          zoom={12}
          options={{ zoomControl: true }}
        >
          {lat && lng && <Marker position={center} />}
        </GoogleMap>
      </div>

      {/* Mobile layout */}
      <div className="block md:hidden mt-4">
        <p style={addressS}>{address}</p>
        <a href={getDirectionsUrl} target="_blank" rel="noopener noreferrer">
          <button style={buttonStyle}>
            <FaDirections style={{ marginRight: "8px" }} />
            Get Directions
          </button>
        </a>
        <GoogleMap
          mapContainerStyle={{ width: "100%", height: "350px" }}
          center={center}
          zoom={12}
          options={{ zoomControl: true }}
        >
          {lat && lng && <Marker position={center} />}
        </GoogleMap>
      </div>
    </div>
        </div>
    );
}

export default Map;
